// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-container[data-v-705c49ab]{padding:20px;height:max(504px,37vh);overflow-y:scroll}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
